<template>
  <div class="bb-home">
    <section class="bb-hero">
      <img class="bb-hero-bg" src="@/assets/ui/pc/Web-banner.webp" alt="" />
      <div class="bb-hero-mask"></div>
      <div class="bb-hero-inner" :class="{ 'is-logged': isLogin }">
        <template v-if="!isLogin">
          <h1>{{ $t("home.homeTitle") }}</h1>
          <p class="bb-hero-sub">
            <img src="@/assets/ui/pc/Frame-web.svg" alt="" />
            {{ $t("home.appLicationInfo") }}
          </p>
          <div class="bb-hero-form">
            <input v-model="registerAccount" type="text" :placeholder="$t('login.email')" />
            <button type="button" @click="goRegister">
              <img src="@/assets/ui/pc/gift_white.png" alt="" />
              {{ $t("navTab.btnSignup") }}
            </button>
          </div>
        </template>
        <template v-else>
          <h1>{{ $t("home.h5Slogan") }}</h1>
          <div class="bb-hero-cta">
            <button class="ghost" type="button" @click="$router.push('/profile/deposit')">{{ $t("home.depositNow") }}</button>
            <button class="brand" type="button" @click="$router.push('/trading')">{{ $t("home.tradeNow") }}</button>
          </div>
        </template>
      </div>
    </section>

    <section class="bb-market" v-if="hasMarketData">
      <h2 class="bb-market-title">{{ $t("home.hotPairs") }}</h2>
      <div class="bb-market-grid">
        <div class="bb-market-card bb-market-main">
          <div class="bb-market-tabs">
            <div
              v-for="(tab, index) in marketTabList"
              :key="tab.value"
              class="bb-market-tab"
              :class="{ active: markTypeIndex === index }"
              @click="markTypeIndex = index"
            >
              {{ tab.label }}
            </div>
          </div>
          <div class="bb-market-rows">
            <div
              class="bb-market-row"
              v-for="item in mainList"
              :key="item.id || item.code"
              @click="toDetail(item)"
            >
              <div class="bb-coin">
                <img v-if="item.logo" :src="item.logo" alt="" />
                <span class="bb-coin-name">
                  {{ pairBase(item) }}<span class="bb-quote">/{{ pairQuote(item) }}</span>
                </span>
              </div>
              <div class="bb-price">{{ item.nowPrice }}</div>
              <div class="bb-chg" :class="chgClass(item.zdf)">{{ formatChg(item.zdf) }}</div>
              <div class="bb-spark">
                <svg viewBox="0 0 80 22" width="80" height="22" aria-hidden="true">
                  <polyline fill="none" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" :stroke="sparkColor(item.zdf)" :points="sparkPoints(item)" />
                </svg>
              </div>
              <button type="button" class="bb-trade" @click.stop="toDetail(item)">{{ $t("home.tradeBtn") }}</button>
            </div>
          </div>
        </div>
        <div class="bb-market-side">
          <div class="bb-market-card">
            <div class="bb-market-tabs">
              <div
                v-for="(tab, index) in gainerTabList"
                :key="'g-' + tab.value"
                class="bb-market-tab"
                :class="{ active: gainerTabIndex === index }"
                @click="gainerTabIndex = index"
              >
                {{ tab.label }} {{ $t("home.gainers") }}
              </div>
            </div>
            <div
              class="bb-side-row"
              v-for="item in gainerList"
              :key="'gainer-' + (item.id || item.code)"
              @click="toDetail(item)"
            >
              <div class="bb-coin">
                <img v-if="item.logo" :src="item.logo" alt="" />
                <span>{{ item.appName || item.code }}</span>
              </div>
              <div class="bb-side-nums">
                <div class="bb-price">{{ item.nowPrice }}</div>
                <div class="bb-chg" :class="chgClass(item.zdf)">{{ formatChg(item.zdf) }}</div>
              </div>
            </div>
          </div>
          <div class="bb-market-card">
            <div class="bb-side-title">{{ $t("home.newListings") }}</div>
            <div
              class="bb-side-row"
              v-for="item in newList"
              :key="'new-' + (item.id || item.code)"
              @click="toDetail(item)"
            >
              <div class="bb-coin">
                <img v-if="item.logo" :src="item.logo" alt="" />
                <span class="bb-coin-name">
                  {{ pairBase(item) }}<span class="bb-quote">/{{ pairQuote(item) }}</span>
                </span>
              </div>
              <div class="bb-side-nums">
                <div class="bb-price">{{ item.nowPrice }}</div>
                <div class="bb-chg" :class="chgClass(item.zdf)">{{ formatChg(item.zdf) }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="bb-market-more" @click="$router.push('/market')">
        <span>{{ $t("navTab.tabMenuMore") }}</span>
        <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
          <path d="m11.803 5.849 4.95 4.95H2.652V13.2h14.103l-4.951 4.951L13.5 19.85 21.349 12 13.5 4.151z" />
        </svg>
      </div>
    </section>

    <section class="bb-security">
      <div class="bb-security-copy">
        <h2>{{ $t("home.button2Title") }}</h2>
        <p>{{ $t("home.button2Title1") }}</p>
        <ul>
          <li>
            <h3>{{ $t("home.button1Title1") }}</h3>
            <p>{{ $t("home.button1Title2") }}</p>
          </li>
          <li>
            <h3>{{ $t("home.button2Title") }}</h3>
            <p>{{ $t("home.button2Title2") }}</p>
          </li>
          <li>
            <h3>{{ $t("home.button3Title") }}</h3>
            <p>{{ $t("home.button3Title2") }}</p>
          </li>
        </ul>
      </div>
      <div class="bb-security-art">
        <video
          class="bb-video"
          autoplay
          muted
          loop
          playsinline
          :poster="shieldPoster"
        >
          <source src="@/assets/ui/pc/security_video_mini.mp4" type="video/mp4" />
        </video>
      </div>
    </section>

    <section class="bb-stats">
      <div class="bb-stats-layout">
        <div class="bb-earth">
          <video class="bb-video" autoplay muted loop playsinline>
            <source src="@/assets/ui/pc/earth_video_v2_mini.mp4" type="video/mp4" />
          </video>
        </div>
        <div class="bb-stats-copy">
          <h2>{{ $t("home.billionInfo") }}</h2>
          <div class="bb-stat-card wide">
            <strong>99.99%</strong>
            <span>{{ $t("home.button3Title1") }}</span>
          </div>
          <div class="bb-stat-grid">
            <div class="bb-stat-card">
              <strong>&lt; 10ms</strong>
              <span>{{ $t("home.button1Title") }}</span>
            </div>
            <div class="bb-stat-card">
              <strong>170+</strong>
              <span>{{ $t("home.CryptocurrenciesListed") }}</span>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="bb-appdown">
      <div class="bb-appdown-copy">
        <h2>{{ $t("home.Application") }}</h2>
        <div class="bb-qr-row">
          <div class="bb-qr">
            <img src="@/assets/ui/pc/qrcode.png" alt="qrcode" />
          </div>
          <div>
            <p class="muted">{{ $t("home.Application") }}</p>
            <p class="strong">iOS / Android</p>
          </div>
        </div>
        <div class="bb-store-btns">
          <button type="button">
            <img src="@/assets/ui/pc/app_download_icon_ios.png" alt="" />
            App Store
          </button>
          <button type="button">
            <img src="@/assets/ui/pc/google-play.png" alt="" />
            Google Play
          </button>
          <button type="button">
            <img src="@/assets/ui/pc/android.png" alt="" />
            Android APK
          </button>
        </div>
      </div>
      <div class="bb-appdown-art">
        <img class="bb-app-bg" src="@/assets/ui/pc/app_bg_v2.webp" alt="" />
        <img class="bb-app-phone" src="@/assets/ui/pc/app_screen_v4-new.webp" alt="" />
      </div>
    </section>

    <section class="bb-faq">
      <h2>{{ $t("home.faqTitle") }}</h2>
      <div class="bb-faq-item" v-for="(item, index) in faqList" :key="index" @click="toggleFaq(index)">
        <div class="bb-faq-title">
          <span>{{ item.q }}</span>
          <svg :class="{ open: openFaq === index }" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path fill="currentColor" fill-rule="evenodd" d="M12 13.444 5.73 7 4 8.778 12 17l8-8.222L18.27 7z" clip-rule="evenodd" />
          </svg>
        </div>
        <div class="bb-faq-body" v-show="openFaq === index">{{ item.a }}</div>
      </div>
      <!-- <div class="bb-faq-cta">
        <button type="button" @click="goRegister">
          <img src="@/assets/ui/pc/gift_black.png" alt="" />
          {{ $t("navTab.btnSignup") }}
        </button>
      </div> -->
    </section>
  </div>
</template>
<script>
import { mapGetters, mapState } from "vuex";
import { listMarketByType } from "@/api/market.js";
import { getSignupPath } from "@/utils/authRedirect";

export default {
  name: "HomePc",
  data() {
    return {
      registerAccount: "",
      marketByType: {},
      markTypeIndex: 0,
      gainerTabIndex: 0,
      openFaq: -1,
      shieldPoster: require("@/assets/ui/pc/shield_v2.webp")
    };
  },
  computed: {
    ...mapState(["isLogin"]),
    ...mapGetters(["marketWsList", "getMarkTypeList"]),
    signupPath() {
      return getSignupPath();
    },
    marketTabList() {
      return this.getMarkTypeList || [];
    },
    gainerTabList() {
      const tabs = this.marketTabList;
      const preferred = tabs.filter((tab) => tab.value === "5" || tab.value === "2");
      return preferred.length ? preferred : tabs.slice(0, 2);
    },
    hasMarketData() {
      return this.marketTabList.some((tab) => (this.marketByType[tab.value] || []).length);
    },
    mainList() {
      const tab = this.marketTabList[this.markTypeIndex];
      const list = (tab && this.marketByType[tab.value]) || [];
      return list.slice(0, 8);
    },
    gainerList() {
      const tab = this.gainerTabList[this.gainerTabIndex];
      const list = [...((tab && this.marketByType[tab.value]) || [])];
      return list
        .sort((a, b) => Number(b.zdf) - Number(a.zdf))
        .slice(0, 4);
    },
    newList() {
      const crypto = this.marketByType["2"] || [];
      const fallbackTab = this.marketTabList[0];
      const source = crypto.length ? crypto : ((fallbackTab && this.marketByType[fallbackTab.value]) || []);
      return source.slice(-3).reverse();
    },
    faqList() {
      return [
        { q: this.$t("home.faqQ1"), a: this.$t("home.faqA1") },
        { q: this.$t("home.faqQ2"), a: this.$t("home.faqA2") },
        { q: this.$t("home.faqQ3"), a: this.$t("home.faqA3") },
        { q: this.$t("home.faqQ4"), a: this.$t("home.faqA4") },
        { q: this.$t("home.faqQ5"), a: this.$t("home.faqA5") }
      ];
    }
  },
  watch: {
    marketWsList: {
      handler(val) {
        if (!val || !val[0]) return;
        Object.keys(this.marketByType).forEach((type) => {
          (this.marketByType[type] || []).forEach((item) => {
            val.forEach((tick) => {
              if (tick.code === item.code) {
                item.nowPrice = tick.price;
                item.zdf = tick.zdf != null ? (Number(tick.zdf) * 100).toFixed(2) : item.zdf;
                if (tick.price != null) {
                  const series = item.hundred || [];
                  const last = series.length ? series[series.length - 1] : null;
                  const lastPrice = last && typeof last === "object" ? last.price : last;
                  if (lastPrice !== tick.price) {
                    series.push(tick.price);
                    if (series.length > 100) series.shift();
                    item.hundred = series;
                  }
                }
              }
            });
          });
        });
      },
      deep: true
    }
  },
  mounted() {
    this.getListMarketByType();
  },
  methods: {
    goRegister() {
      const query = this.registerAccount ? { account: this.registerAccount } : {};
      this.$router.push({ path: this.signupPath, query });
    },
    toggleFaq(index) {
      this.openFaq = this.openFaq === index ? -1 : index;
    },
    toDetail(item) {
      this.$router.push({
        path: "/trade/futures",
        query: { code: item.code, type: item.type, id: item.id }
      });
    },
    normalizeItem(item) {
      return {
        ...item,
        nowPrice: item.nowPrice || item.price,
        zdf: item.zdf != null ? (Number(item.zdf) * 100).toFixed(2) : "0.00",
        hundred: item.hundred || []
      };
    },
    pairParts(item) {
      const name = String(item.appName || item.code || "");
      if (name.includes("/")) {
        const parts = name.split("/");
        return [parts[0], parts.slice(1).join("/") || "USD"];
      }
      const quotes = ["USDT", "USDC", "USD", "BTC", "ETH"];
      const upper = name.toUpperCase();
      for (let i = 0; i < quotes.length; i++) {
        const q = quotes[i];
        if (upper.endsWith(q) && name.length > q.length) {
          return [name.slice(0, name.length - q.length), q];
        }
      }
      return [name, "USD"];
    },
    pairBase(item) {
      return this.pairParts(item)[0];
    },
    pairQuote(item) {
      return this.pairParts(item)[1];
    },
    chgClass(zdf) {
      const n = Number(zdf);
      if (n > 0) return "up";
      if (n < 0) return "down";
      return "";
    },
    formatChg(zdf) {
      const n = Number(zdf);
      if (n > 0) return "+" + zdf + "%";
      return zdf + "%";
    },
    sparkColor(zdf) {
      const style = typeof window !== "undefined" ? getComputedStyle(document.documentElement) : null;
      const up = (style && style.getPropertyValue("--bb-up").trim()) || "#44b400";
      const down = (style && style.getPropertyValue("--bb-down").trim()) || "#ff2828";
      return Number(zdf) >= 0 ? up : down;
    },
    sparkPoints(item) {
      const raw = item.hundred || [];
      const values = raw
        .map((p) => (p && typeof p === "object" ? Number(p.price) : Number(p)))
        .filter((n) => !isNaN(n));
      if (values.length < 2) return "";
      const w = 80;
      const h = 22;
      const min = Math.min.apply(null, values);
      const max = Math.max.apply(null, values);
      const span = max - min || 1;
      return values
        .map((v, i) => {
          const x = (i / (values.length - 1)) * w;
          const y = h - ((v - min) / span) * (h - 2) - 1;
          return x + "," + y;
        })
        .join(" ");
    },
    getListMarketByType() {
      const tabs = this.marketTabList;
      Promise.all(
        tabs.map((tab) =>
          listMarketByType({ type: tab.value })
            .then((res) => {
              const list = (res && res.result) || [];
              return {
                type: tab.value,
                list: (Array.isArray(list) ? list : []).map((item) => this.normalizeItem(item))
              };
            })
            .catch(() => ({ type: tab.value, list: [] }))
        )
      ).then((groups) => {
        const next = {};
        groups.forEach((group) => {
          next[group.type] = group.list;
        });
        this.marketByType = next;
      });
    }
  }
};
</script>
<style scoped>
.bb-home {
  background: var(--bb-bg);
  color: var(--bb-text);
  padding-bottom: 160px;
  overflow-x: hidden;
}
.bb-hero {
  position: relative;
  min-height: 624px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  color: var(--bb-always-white);
}
.bb-hero-inner {
  position: relative;
  z-index: 2;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 82px 16px 40px;
  text-align: center;
}
.bb-hero-inner.is-logged {
  min-height: 624px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding-bottom: 48px;
}
.bb-hero-inner.is-logged h1 {
  margin: 0;
  max-width: 760px;
  margin-left: auto;
  margin-right: auto;
}
.bb-hero-cta {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
}
.bb-hero-cta button {
  height: 48px;
  padding: 0 32px;
  border: 0;
  border-radius: 6px;
  font-size: 16px;
  font-weight: 500;
  line-height: 1.5;
  cursor: pointer;
}
.bb-hero-cta .ghost {
  background: rgba(255, 255, 255, 0.2);
  color: var(--bb-always-white);
}
.bb-hero-cta .ghost:hover {
  background: rgba(255, 255, 255, 0.3);
}
.bb-hero-cta .brand {
  background: var(--bb-brand);
  color: var(--bb-always-black);
}
.bb-hero-cta .brand:hover {
  background: var(--bb-brand-hover);
}
.bb-hero-bg {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center bottom;
  opacity: 0.9;
}
.bb-hero-mask {
  position: absolute;
  inset: 0;
  background: linear-gradient(to right, var(--bb-bg) 0%, transparent 30%, transparent 70%, var(--bb-bg) 100%);
  pointer-events: none;
}
.bb-hero h1 {
  margin: 0 0 24px;
  font-size: 52px;
  line-height: 62px;
  font-weight: 700;
}
.bb-hero-sub {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  font-size: 14px;
  color: var(--bb-always-white);
  margin: 0 0 16px;
}
.bb-hero-sub img {
  width: 16px;
  height: 16px;
}
.bb-hero-form {
  width: 560px;
  max-width: 100%;
  margin: 0 auto;
  height: 48px;
  display: flex;
  align-items: center;
  background: var(--bb-always-white);
  border-radius: 8px;
  overflow: hidden;
  padding-left: 12px;
}
.bb-hero-form input {
  flex: 1;
  min-width: 0;
  border: none;
  outline: none;
  height: 100%;
  font-size: 14px;
  color: var(--bb-always-black);
  background: transparent;
}
.bb-hero-form button {
  height: 44px;
  margin: 2px;
  padding: 0 24px;
  border: none;
  border-radius: 6px;
  background: var(--bb-brand);
  color: var(--bb-always-white);
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 6px;
}
.bb-hero-form button img {
  width: 20px;
  height: 20px;
}
.bb-market,
.bb-stats,
.bb-faq {
  max-width: 1200px;
  margin: 120px auto 0;
  padding: 0 16px;
}
.bb-market-title {
  margin: 0 0 48px;
  font-size: 40px;
  line-height: 48px;
  font-weight: 700;
  text-align: center;
}
.bb-market-grid {
  display: flex;
  justify-content: space-between;
  gap: 20px;
}
.bb-market-card {
  background: var(--bb-card-glass);
  border-radius: 20px;
  overflow: hidden;
}
.bb-market-main {
  width: 798px;
  flex: 1;
  padding: 16px 0 20px;
}
.bb-market-side {
  width: 382px;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  gap: 16px;
  justify-content: space-between;
}
.bb-market-side .bb-market-card {
  padding: 16px 0;
}
.bb-market-tabs {
  display: flex;
  gap: 16px;
  padding: 0 24px;
  margin-bottom: 4px;
}
.bb-market-tab {
  position: relative;
  padding: 10px 0;
  cursor: pointer;
  color: var(--bb-text-tertiary);
  font-size: 16px;
  font-weight: 500;
  white-space: nowrap;
}
.bb-market-tab:hover,
.bb-market-tab.active {
  color: var(--bb-text);
}
.bb-market-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 64px;
  padding: 0 24px;
  cursor: pointer;
}
.bb-market-row:hover,
.bb-side-row:hover {
  background: var(--bb-hover);
}
.bb-coin {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 190px;
  flex-shrink: 0;
  font-weight: 500;
  min-width: 0;
}
.bb-coin img {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  flex-shrink: 0;
}
.bb-coin-name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.bb-quote {
  color: var(--bb-text-tertiary);
  font-size: 12px;
  font-weight: 400;
}
.bb-price {
  width: 140px;
  text-align: right;
  flex-shrink: 0;
  font-size: 14px;
}
.bb-chg {
  width: 140px;
  text-align: right;
  flex-shrink: 0;
  color: var(--bb-text-tertiary);
  font-size: 14px;
}
.bb-chg.up {
  color: var(--bb-up);
}
.bb-chg.down {
  color: var(--bb-down);
}
.bb-spark {
  width: 140px;
  display: flex;
  justify-content: flex-end;
  flex-shrink: 0;
}
.bb-trade {
  margin-right: 8px;
  height: 32px;
  min-width: 68px;
  padding: 0 16px;
  border: 0;
  border-radius: 8px;
  background: var(--bb-bg-input);
  color: var(--bb-text);
  font-size: 14px;
  cursor: pointer;
  flex-shrink: 0;
}
.bb-trade:hover {
  background: var(--bb-hover);
}
.bb-side-title {
  padding: 10px 24px;
  font-size: 16px;
  font-weight: 500;
}
.bb-side-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 64px;
  padding: 0 24px;
  cursor: pointer;
}
.bb-side-row .bb-coin {
  width: 160px;
}
.bb-side-nums {
  flex: 1;
  text-align: right;
}
.bb-side-nums .bb-price,
.bb-side-nums .bb-chg {
  width: auto;
  display: block;
}
.bb-side-nums .bb-chg {
  font-size: 12px;
}
.bb-market-more {
  margin-top: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  width: fit-content;
  margin-left: auto;
  margin-right: auto;
  padding: 12px 24px;
  background: var(--bb-card-glass);
  border-radius: 8px;
  cursor: pointer;
  font-weight: 600;
}
.bb-section-head {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  margin-bottom: 24px;
}
.bb-section-head h2,
.bb-stats h2,
.bb-faq h2,
.bb-security-copy h2,
.bb-appdown-copy h2 {
  margin: 0;
  font-size: 40px;
  line-height: 48px;
  font-weight: 700;
}
.bb-more {
  color: var(--bb-brand);
  cursor: pointer;
  font-size: 14px;
}
.bb-security {
  max-width: 1200px;
  margin: 120px auto 0;
  padding: 80px 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 48px;
  background: var(--bb-section-tint);
}
.bb-security-copy {
  flex: 1;
  max-width: 600px;
}
.bb-security-copy > p,
.bb-security-copy li p {
  color: var(--bb-text-tertiary);
  font-size: 14px;
  line-height: 20px;
}
.bb-security-copy ul {
  list-style: none;
  padding: 0;
  margin: 32px 0 0;
}
.bb-security-copy li {
  margin-bottom: 24px;
}
.bb-security-copy h3 {
  margin: 0 0 8px;
  font-size: 18px;
  padding-left: 14px;
  position: relative;
}
.bb-security-copy h3::before {
  content: "";
  position: absolute;
  left: 0;
  top: 8px;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: var(--bb-brand);
}
.bb-security-art {
  width: 420px;
  flex-shrink: 0;
}
.bb-security-art img,
.bb-security-art .bb-video {
  width: 100%;
  height: auto;
  display: block;
}
.bb-video {
  width: 100%;
  height: auto;
  display: block;
  background: transparent;
  pointer-events: none;
}
.bb-stats {
  max-width: 1200px;
  margin: 120px auto 0;
  padding: 0 16px;
}
.bb-stats-layout {
  display: flex;
  align-items: center;
  gap: 48px;
}
.bb-earth {
  flex: 1;
  min-width: 0;
  opacity: 0.85;
}
.bb-earth .bb-video {
  max-width: 460px;
  margin: 0 auto;
}
.bb-stats-copy {
  width: 700px;
  max-width: 100%;
  flex-shrink: 0;
}
.bb-stat-card {
  backdrop-filter: blur(15px);
  border-radius: 16px;
  border: 0.5px solid var(--bb-border);
  background: var(--bb-stat-bg);
  box-shadow: var(--bb-stat-inset);
  padding: 40px 24px;
  text-align: center;
}
.bb-stat-card.wide {
  margin: 24px 0 20px;
}
.bb-stat-card strong {
  display: block;
  font-size: 40px;
  margin-bottom: 8px;
}
.bb-stat-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
}
.bb-appdown {
  max-width: 1200px;
  width: 100%;
  margin: 120px auto 0;
  padding: 0 16px;
  position: relative;
  min-width: 0;
  box-sizing: border-box;
  overflow: hidden;
}
.bb-appdown-copy {
  position: relative;
  z-index: 2;
  width: 100%;
  max-width: 720px;
  min-width: 0;
  padding-right: 24px;
  box-sizing: border-box;
}
.bb-qr-row {
  display: flex;
  align-items: center;
  gap: 20px;
  margin: 32px 0 24px;
}
.bb-qr {
  width: 160px;
  height: 160px;
  flex-shrink: 0;
  border-radius: 14px;
  background: var(--bb-always-white);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px;
  box-sizing: border-box;
}
.bb-qr img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.muted {
  color: var(--bb-text-secondary);
  margin: 0 0 6px;
}
.strong {
  font-size: 28px;
  font-weight: 700;
  margin: 0;
}
.bb-store-btns {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
}
.bb-store-btns button {
  flex: 1 1 160px;
  width: auto;
  max-width: 190px;
  min-width: 0;
  height: 52px;
  border: none;
  border-radius: 8px;
  background: var(--bb-bg-card);
  color: var(--bb-text);
  font-weight: 700;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  box-sizing: border-box;
}
.bb-store-btns button img {
  width: 20px;
  height: 20px;
}
.bb-appdown-art {
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  width: 420px;
  max-width: 42%;
  z-index: 1;
  pointer-events: none;
  overflow: hidden;
}
.bb-app-bg {
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  width: auto;
  height: 100%;
  max-height: 100%;
  opacity: 0.7;
  object-fit: contain;
  object-position: right center;
}
.bb-app-phone {
  position: absolute;
  right: 24px;
  top: 50%;
  transform: translateY(-50%);
  z-index: 1;
  height: 100%;
  width: auto;
  max-height: 100%;
  object-fit: contain;
  object-position: right center;
  display: block;
}
@media (max-width: 1100px) {
  .bb-appdown-copy {
    max-width: 100%;
  }
  .bb-store-btns button {
    max-width: none;
  }
  .bb-appdown-art {
    max-width: 50%;
    right: 0;
  }
}
.bb-faq h2 {
  text-align: center;
  margin-bottom: 40px;
}
.bb-faq-item {
  border-bottom: 0.5px solid var(--bb-divider);
  padding: 28px 0;
  cursor: pointer;
}
.bb-faq-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 20px;
  font-weight: 600;
}
.bb-faq-title svg {
  transition: transform 0.2s;
}
.bb-faq-title svg.open {
  transform: rotate(180deg);
}
.bb-faq-body {
  margin-top: 12px;
  color: var(--bb-text-tertiary);
  font-size: 14px;
  line-height: 1.7;
  white-space: pre-line;
}
.bb-faq-cta {
  display: flex;
  justify-content: center;
  margin-top: 48px;
}
.bb-faq-cta button {
  height: 48px;
  padding: 0 40px;
  border: none;
  border-radius: 8px;
  background: var(--bb-brand);
  color: var(--bb-always-black);
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 8px;
}
.bb-faq-cta button img {
  width: 20px;
  height: 20px;
}
</style>
